(function(){
            var desktop = window.matchMedia('(min-width: 750px)');
            function setupVc40(){
              var root = document.getElementById('pi-ge-pi');
              if (!root) return;
              root.querySelectorAll('[data-pi-vc40]').forEach(function(wrap){
                var autoplay = wrap.getAttribute('data-pi-vc-autoplay') === 'true';
                if (!wrap.__vc40NoCtx) {
                  wrap.addEventListener('contextmenu', function(e){ if (desktop.matches) e.preventDefault(); });
                  wrap.__vc40NoCtx = true;
                }
                wrap.querySelectorAll('video').forEach(function(video){
                  if (autoplay) {
                    video.muted = true; video.defaultMuted = true;
                    video.setAttribute('muted', ''); video.setAttribute('playsinline', '');
                    video.setAttribute('autoplay', ''); video.setAttribute('loop', '');
                    video.playsInline = true; video.autoplay = true; video.loop = true;
                    var play = function(){ var p = video.play(); if (p && p.catch) p.catch(function(){}); };
                    if (video.readyState >= 2) play();
                    else video.addEventListener('loadeddata', play, { once: true });
                  }
                  video.setAttribute('controlsList', 'nodownload noplaybackrate noremoteplayback');
                  video.setAttribute('disablePictureInPicture', '');
                  video.disablePictureInPicture = true;
                  if (desktop.matches) {
                    video.removeAttribute('controls'); video.controls = false;
                  } else {
                    video.setAttribute('controls', ''); video.controls = true;
                  }
                });
              });
            }
            if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupVc40);
            else setupVc40();
            document.addEventListener('shopify:section:load', setupVc40);
            if (desktop.addEventListener) desktop.addEventListener('change', setupVc40);
            else if (desktop.addListener) desktop.addListener(setupVc40);
          })();
;
(function() {
    function onChoiceClick(event) {
      var btn = event.target.closest('[data-pi-mini-quiz-choice]');
      if (!btn) return;
      var wrap = btn.closest('[data-pi-mini-quiz]');
      if (!wrap) return;
      wrap.querySelectorAll('[data-pi-mini-quiz-choice]').forEach(function(choice) {
        choice.classList.toggle('active', choice === btn);
      });
      var result = wrap.querySelector('[data-pi-mini-quiz-result]');
      if (result) result.textContent = btn.getAttribute('data-result') || '';
    }
    if (!window.__piMiniQuizBound) {
      document.addEventListener('click', onChoiceClick);
      window.__piMiniQuizBound = true;
    }
  })();
;
(function() {
  const rootSelector = '#pi-ge-pi';
  function setMuteIcon(button, unmuted) {
    if (!button) return;
    button.innerHTML = unmuted
      ? '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M3,9H7L12,4V20L7,15H3V9Z" fill="white"/><path d="M16.5,12C16.5,10.23 15.48,8.71 14,7.97V16.02C15.48,15.29 16.5,13.77 16.5,12Z" fill="white"/><path d="M14,3.23V5.29C16.89,6.15 19,8.83 19,12C19,15.17 16.89,17.85 14,18.71V20.77C18.01,19.86 21,16.28 21,12C21,7.72 18.01,4.14 14,3.23Z" fill="white"/></svg>'
      : '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M12,4L9.91,6.09L12,8.18M4.27,3L3,4.27L7.73,9H3V15H7L12,20V13.27L16.25,17.53C15.58,18.04 14.83,18.46 14,18.7V20.77C15.38,20.45 16.63,19.82 17.68,18.96L19.73,21L21,19.73L12,10.73M19,12C19,12.94 18.8,13.82 18.46,14.64L19.97,16.15C20.62,14.91 21,13.5 21,12C21,7.72 18,4.14 14,3.23V5.29C16.89,6.15 19,8.83 19,12M16.5,12C16.5,10.23 15.5,8.71 14,7.97V10.18L16.45,12.63C16.5,12.43 16.5,12.21 16.5,12Z" fill="white"/></svg>';
    button.setAttribute('aria-label', unmuted ? 'Mute video' : 'Unmute video');
  }
  function initFrVideoCarousel() {
    const root = document.querySelector(rootSelector);
    if (!root) return;
    const cards = root.querySelectorAll('.fr-video-item:not([data-fr-video-ready])');
    cards.forEach((item) => {
      item.setAttribute('data-fr-video-ready', 'true');
      const video = item.querySelector('video.fr-carousel-video, .fr-video-thumbnail video');
      const playButton = item.querySelector('.fr-play-button');
      const unmuteButton = item.querySelector('.fr-unmute-button');
      const thumbnail = item.querySelector('.fr-video-thumbnail');
      if (!video) {
        if (playButton) playButton.style.display = 'none';
        if (unmuteButton) unmuteButton.style.display = 'none';
        return;
      }
      video.muted = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('preload', 'metadata');
      video.addEventListener('loadeddata', function() {
        try {
          if (video.currentTime === 0) video.currentTime = 0.1;
        } catch(e) {}
      });
      if (video.readyState === 0) {
        try { video.load(); } catch(e) {}
      }
      function pauseOtherVideos() {
        root.querySelectorAll('.fr-carousel-video, .fr-video-thumbnail video').forEach((other) => {
          if (other !== video && !other.paused) {
            other.pause();
            const otherItem = other.closest('.fr-video-item');
            if (otherItem) {
              const otherPlay = otherItem.querySelector('.fr-play-button');
              const otherMute = otherItem.querySelector('.fr-unmute-button');
              if (otherPlay) otherPlay.style.display = 'block';
              if (otherMute) {
                otherMute.classList.remove('visible', 'unmuted');
                setMuteIcon(otherMute, false);
              }
            }
          }
        });
      }
      function togglePlay(event) {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }
        if (video.paused) {
          pauseOtherVideos();
          video.muted = true;
          setMuteIcon(unmuteButton, false);
          video.play().then(() => {
            if (playButton) playButton.style.display = 'none';
            if (unmuteButton) {
              window.setTimeout(() => unmuteButton.classList.add('visible'), 300);
            }
          }).catch(() => {
            if (playButton) playButton.style.display = 'block';
          });
        } else {
          video.pause();
          if (playButton) playButton.style.display = 'block';
          if (unmuteButton) {
            unmuteButton.classList.remove('visible', 'unmuted');
            setMuteIcon(unmuteButton, false);
          }
        }
      }
      if (playButton) playButton.addEventListener('click', togglePlay);
      if (thumbnail) {
        thumbnail.addEventListener('click', function(e) {
          if (!e.target.closest('.fr-play-button') && !e.target.closest('.fr-unmute-button')) togglePlay(e);
        });
      }
      video.addEventListener('ended', function() {
        if (playButton) playButton.style.display = 'block';
        if (unmuteButton) {
          unmuteButton.classList.remove('visible', 'unmuted');
          setMuteIcon(unmuteButton, false);
        }
        try { video.currentTime = 0; } catch(e) {}
      });
      if (unmuteButton) {
        setMuteIcon(unmuteButton, false);
        unmuteButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          const willUnmute = video.muted;
          video.muted = !willUnmute;
          unmuteButton.classList.toggle('unmuted', willUnmute);
          setMuteIcon(unmuteButton, willUnmute);
          if (willUnmute && video.paused) {
            video.play().catch(() => {});
            if (playButton) playButton.style.display = 'none';
          }
        });
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFrVideoCarousel);
  } else {
    initFrVideoCarousel();
  }
  document.addEventListener('shopify:section:load', initFrVideoCarousel);
  document.addEventListener('shopify:block:select', initFrVideoCarousel);
})();
;
(function() {
  const rootSelector = '#pi-ge-pi';
  function setVc39MuteIcon(button, unmuted) {
    if (!button) return;
    button.innerHTML = unmuted
      ? '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M3,9H7L12,4V20L7,15H3V9Z" fill="white"/><path d="M16.5,12C16.5,10.23 15.48,8.71 14,7.97V16.02C15.48,15.29 16.5,13.77 16.5,12Z" fill="white"/><path d="M14,3.23V5.29C16.89,6.15 19,8.83 19,12C19,15.17 16.89,17.85 14,18.71V20.77C18.01,19.86 21,16.28 21,12C21,7.72 18.01,4.14 14,3.23Z" fill="white"/></svg>'
      : '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M12,4L9.91,6.09L12,8.18M4.27,3L3,4.27L7.73,9H3V15H7L12,20V13.27L16.25,17.53C15.58,18.04 14.83,18.46 14,18.7V20.77C15.38,20.45 16.63,19.82 17.68,18.96L19.73,21L21,19.73L12,10.73M19,12C19,12.94 18.8,13.82 18.46,14.64L19.97,16.15C20.62,14.91 21,13.5 21,12C21,7.72 18,4.14 14,3.23V5.29C16.89,6.15 19,8.83 19,12M16.5,12C16.5,10.23 15.5,8.71 14,7.97V10.18L16.45,12.63C16.5,12.43 16.5,12.21 16.5,12Z" fill="white"/></svg>';
    button.setAttribute('aria-label', unmuted ? 'Mute video' : 'Unmute video');
  }
  function initVc39() {
    const root = document.querySelector(rootSelector);
    if (!root) return;
    root.querySelectorAll('.pi-vc39-item:not([data-vc39-ready])').forEach((item) => {
      item.setAttribute('data-vc39-ready', 'true');
      const video = item.querySelector('video.pi-vc39-video, .pi-vc39-thumb video');
      const play = item.querySelector('.pi-vc39-play');
      const mute = item.querySelector('.pi-vc39-mute');
      const thumb = item.querySelector('.pi-vc39-thumb');
      if (!video) {
        if (mute) mute.style.display = 'none';
        return;
      }
      video.muted = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('preload', 'metadata');
      try { if (video.readyState === 0) video.load(); } catch(e) {}
      function pauseOthers() {
        root.querySelectorAll('.pi-vc39 video').forEach((other) => {
          if (other !== video && !other.paused) {
            other.pause();
            const otherItem = other.closest('.pi-vc39-item');
            if (!otherItem) return;
            const otherPlay = otherItem.querySelector('.pi-vc39-play');
            const otherMute = otherItem.querySelector('.pi-vc39-mute');
            if (otherPlay) otherPlay.style.display = 'block';
            if (otherMute) {
              otherMute.classList.remove('is-visible', 'is-unmuted');
              setVc39MuteIcon(otherMute, false);
            }
          }
        });
      }
      function togglePlay(e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        if (video.paused) {
          pauseOthers();
          video.muted = true;
          setVc39MuteIcon(mute, false);
          video.play().then(() => {
            if (play) play.style.display = 'none';
            if (mute) setTimeout(() => mute.classList.add('is-visible'), 250);
          }).catch(() => {
            if (play) play.style.display = 'block';
          });
        } else {
          video.pause();
          if (play) play.style.display = 'block';
          if (mute) {
            mute.classList.remove('is-visible', 'is-unmuted');
            setVc39MuteIcon(mute, false);
          }
        }
      }
      if (play) play.addEventListener('click', togglePlay);
      if (thumb) {
        thumb.addEventListener('click', function(e) {
          if (!e.target.closest('.pi-vc39-play') && !e.target.closest('.pi-vc39-mute')) togglePlay(e);
        });
      }
      video.addEventListener('ended', function() {
        if (play) play.style.display = 'block';
        if (mute) {
          mute.classList.remove('is-visible', 'is-unmuted');
          setVc39MuteIcon(mute, false);
        }
        try { video.currentTime = 0; } catch(e) {}
      });
      if (mute) {
        setVc39MuteIcon(mute, false);
        mute.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          const willUnmute = video.muted;
          video.muted = !willUnmute;
          mute.classList.toggle('is-unmuted', willUnmute);
          setVc39MuteIcon(mute, willUnmute);
          if (willUnmute && video.paused) togglePlay(e);
        });
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVc39);
  } else {
    initVc39();
  }
  document.addEventListener('shopify:section:load', initVc39);
  document.addEventListener('shopify:block:select', initVc39);
})();